import React, { useState, useEffect } from 'react';
import { api } from '../../api';

const UsuariosSection = () => {
  const [usuarios,     setUsuarios]     = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [editingUser,  setEditingUser]  = useState(null);
  const [searchTerm,   setSearchTerm]   = useState('');

  useEffect(() => { loadUsuarios(); }, []);

  const loadUsuarios = async () => {
    try {
      setLoading(true);
      const data = await api.get('/users');
      setUsuarios(Array.isArray(data) ? data : data.users || []);
    } catch (error) {
      console.error('Error cargando usuarios:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!editingUser) return;
    try {
      const uid = editingUser.id || editingUser._id;
      const { id, _id, newPassword, ...updateData } = editingUser;
      await api.put(`/users/${uid}`, updateData);
      if (newPassword && newPassword.trim().length >= 6) {
        await api.put(`/users/${uid}/password`, { password: newPassword.trim() });
      }
      setUsuarios(prev => prev.map(u => (u.id || u._id) === uid ? { ...editingUser, newPassword: undefined } : u));
      setEditingUser(null);
      alert('Usuario actualizado correctamente');
    } catch (error) {
      alert('Error al actualizar usuario: ' + error.message);
    }
  };

  const handleDelete = async (userId, userName) => {
    if (!window.confirm(`¿Está seguro de eliminar al usuario ${userName}?`)) return;
    try {
      await api.delete(`/users/${userId}`);
      setUsuarios(prev => prev.filter(u => (u.id || u._id) !== userId));
      alert('Usuario eliminado correctamente');
    } catch (error) {
      alert('Error al eliminar usuario: ' + error.message);
    }
  };

  const filteredUsuarios = usuarios.filter(u =>
    u.nombre?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    u.apellido?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    u.aditamento?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    u.role?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return (
    <div className="section-loading"><div className="spinner"></div><p>Cargando usuarios...</p></div>
  );

  return (
    <div className="section-container">
      <div className="section-header">
        <h1>Gestión de Usuarios</h1>
        <p>Administre propietarios y choferes del sistema</p>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Buscar por nombre, apellido, aditamento o rol..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <span className="search-results">{filteredUsuarios.length} usuario(s) encontrado(s)</span>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Nombre</th><th>Apellido</th><th>Email</th><th>Aditamento</th>
              <th>Rol</th><th>Turno Activo</th><th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsuarios.map(usuario => {
              const uid = usuario.id || usuario._id;
              return (
                <tr key={uid}>
                  <td>{usuario.nombre || 'N/A'}</td>
                  <td>{usuario.apellido || 'N/A'}</td>
                  <td>{usuario.email || 'N/A'}</td>
                  <td><span className="aditamento-badge">{usuario.aditamento || 'N/A'}</span></td>
                  <td>
                    <span className={`role-badge ${usuario.role}`}>
                      {usuario.role === 'propietario' ? 'Propietario' : usuario.role === 'chofer' ? 'Chofer' : usuario.role || 'N/A'}
                    </span>
                  </td>
                  <td>
                    <span className={`status-badge ${usuario.isShiftStarted ? 'active' : 'inactive'}`}>
                      {usuario.isShiftStarted ? 'Sí' : 'No'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button className="btn btn-sm btn-primary" onClick={() => setEditingUser({ ...usuario, id: uid })}>Editar</button>
                      <button className="btn btn-sm btn-danger"  onClick={() => handleDelete(uid, `${usuario.nombre} ${usuario.apellido}`)}>Eliminar</button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {filteredUsuarios.length === 0 && <div className="no-data"><p>No se encontraron usuarios</p></div>}
      </div>

      {editingUser && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h3>Editar Usuario</h3>
              <button className="modal-close" onClick={() => setEditingUser(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group">
                  <label>Nombre</label>
                  <input type="text" value={editingUser.nombre || ''} className="form-control"
                    onChange={e => setEditingUser(p => ({ ...p, nombre: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label>Apellido</label>
                  <input type="text" value={editingUser.apellido || ''} className="form-control"
                    onChange={e => setEditingUser(p => ({ ...p, apellido: e.target.value }))} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Email (login)</label>
                  <input type="email" value={editingUser.email || ''} className="form-control"
                    onChange={e => setEditingUser(p => ({ ...p, email: e.target.value }))} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Aditamento</label>
                  <input type="text" value={editingUser.aditamento || ''} className="form-control"
                    onChange={e => setEditingUser(p => ({ ...p, aditamento: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label>Rol</label>
                  <select value={editingUser.role || ''} className="form-control"
                    onChange={e => setEditingUser(p => ({ ...p, role: e.target.value }))}>
                    <option value="">Seleccionar rol</option>
                    <option value="propietario">Propietario</option>
                    <option value="chofer">Chofer</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Nueva Contraseña <span style={{color:'#888', fontWeight:400}}>(dejar vacío para no cambiar)</span></label>
                  <input type="password" value={editingUser.newPassword || ''} className="form-control"
                    placeholder="Mínimo 6 caracteres"
                    onChange={e => setEditingUser(p => ({ ...p, newPassword: e.target.value }))} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setEditingUser(null)}>Cancelar</button>
              <button className="btn btn-primary"   onClick={handleSave}>Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsuariosSection;
